<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13EKxtk/tc-custom/9781250020475.jpg?1737771340427" alt="This image is the cover for the book Runaway Man, A Benji Golden Mystery"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Runaway Man, A Benji Golden Mystery
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The first in a smart and funny series from award-winning author David Handler, featuring an irresistible young PI in New York City.<br/></b><br/>Benji Golden works in his family's struggling mom-and-pop business above a twenty-four-hour diner on Broadway and West 103rd Street. Golden Legal Services, a private detective agency, was started by Benji's hero-cop father. The business is now run by Benji's mother, who used to be the only Jewish pole dancer in New York City, and is staffed by Lovely Rita, an eye-popping computer wizard and a former lap dancer.<br/><br/>Baby-faced Benji—who is exactly one-quarter inch shy of five-foot-six, weighs a buck thirty-seven, and answers to the nickname "Bunny"—specializes in tracking down teen runaways. One day, when a lawyer in fancy shoes arrives from Park Avenue's classiest law firm offering a job and lots of money, Benji and his mother can't say no. <br/><br/>Bruce Weiner is a senior at prestigious Canterbury College. A client of the firm has bestowed a considerable inheritance on Bruce, but Bruce has gone missing, and it's up to Benji to find him. One murder later, Benji finds himself on a dangerous investigation that will take him to the highly secretive core of the most powerful city on earth.<br/><br/><i>Runaway Man</i> delivers all that a David Handler novel promises: smart humor, a thrilling and sexy story, and characters you won't soon forget.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Handler
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Dunne Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?89e8ca0a